import React from 'react';
import { Container } from '@mui/material';
import DataCollectionHelper from '../components/DataCollectionHelper';

const DataCollectionHelperPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <DataCollectionHelper />
    </Container>
  );
};

export default DataCollectionHelperPage;